import {filter, map} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';
type KlineMsg = ws.KlineMsg;

export const klineMsg$ = wsMsg$.pipe(
  filter((o: KlineMsg) => !!o.kline || !!o.kline_p),
  map(convertKline)
);

function convertKline({kline, kline_p, ...data}) {
  let klineItems = kline ? kline : kline_p;
  // 非交易symbol交易量置为0，TE支持以后此处逻辑可以移除
  if (data.symbol.startsWith('.')) {
    klineItems = klineItems.map((o) => {
      o[7] = 0;
      return o;
    });
  }
  return {...data, kline: klineItems};
}
